export default "__VITE_ASSET__CJivxNZb__"